// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimGroupViewSearchGroupViewSearchRequest {
    static getAttributeTypeMap() {
        return ClaimV1ClaimGroupViewSearchGroupViewSearchRequest.attributeTypeMap;
    }
}
ClaimV1ClaimGroupViewSearchGroupViewSearchRequest.discriminator = undefined;
ClaimV1ClaimGroupViewSearchGroupViewSearchRequest.additionalProperties = false;
ClaimV1ClaimGroupViewSearchGroupViewSearchRequest.attributeTypeMap = [
    {
        "name": "start",
        "baseName": "start",
        "type": "number"
    },
    {
        "name": "pageSize",
        "baseName": "pageSize",
        "type": "number"
    },
    {
        "name": "searchModel",
        "baseName": "searchModel",
        "type": "ClaimGroupViewSearchModel"
    },
];
//# sourceMappingURL=claimV1ClaimGroupViewSearchGroupViewSearchRequest.js.map